<template>
  <div class="v-go-top">
    <div class="wrap">
      <a href="javascript:void(0)">
        <span class="glyphicon glyphicon-chevron-up"></span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  mounted () {
    var $window = $(window)

    $window.on('scroll', function () {
      var scrollTop = $window.scrollTop()
      if (scrollTop > 100) {
        $('.header-travel-guide-mobile').fadeIn()
      } else {
        $('.header-travel-guide-mobile').fadeOut()
      }
    }).trigger('scroll')

    $('.gotop').on('click', function () {
      $('body,html').animate({ 'scrollTop': 0 })
    })
  }
}
</script>
<style lang="scss">
.v-go-top {
  display: none;
  position: fixed;
  bottom: 15%;
  right: 0;
  left: 0;

  .wrap {
    position: relative;
    max-width: $wrap-max-width;
    margin: auto;
    padding: 0 15px;
  }

  a {
    position: absolute;
    right: 20px;
    border-radius: 5px;
    width: 45px;
    height: 45px;
    font-size: 14px;
    text-align: center;
    line-height: 45px;
    color: #fff;
    background: #f3a660;

    &:hover {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/go-top/GoTop.vue